import React from 'react';
import { useTranslation } from 'react-i18next';
import { bell } from 'static/icons/resizable';
import { Icon, Text } from 'view/atoms';
import { useShouldShowNotificationBubble } from 'hooks';
import * as ContainerStyles from '../../ProfileMenu.styles';
import * as S from './NotificationButton.styles';

type Props = {
  onClick: () => void;
};

export const NotificationButton = ({ onClick }: Props) => {
  const { t } = useTranslation();
  const showNotificationBubble = useShouldShowNotificationBubble();

  return (
    <ContainerStyles.ProfileButton onClick={onClick}>
      <S.IconWrapper>
        <Icon src={bell} alt='Notification Bell' />
        {showNotificationBubble && (
          <S.IconBubble aria-label='Notification bubble' />
        )}
      </S.IconWrapper>
      <Text kind='body'>{t('other.notifications')}</Text>
    </ContainerStyles.ProfileButton>
  );
};
